export const form = {
    username: {
        reset: "Effacer le nom d'utilisateur",
        delete: 'Supprimer ce compte local',
        label: "Nom d'utilisateur (entre 3 et 64 caractères)",
        error: "Merci de saisir un nom d'utilisateur valide (entre 3 et 64 caractères)"
    },
    email: {
        reset: "Effacer l'email",
        delete: 'Supprimer ce compte local',
        select: {
            label: '* Identifiant (email)',
        },
        label: 'Identifiant (email)',
        btnOtherAccount: 'Se connecter avec un autre compte',
        btnNewAccount: 'Se connecter avec un compte existant',
        btnRemoveAccount: 'Supprimer ce compte',
    },
    password: {
        normal: {
            label: 'Mot de passe',
            show: 'Afficher le mot de passe',
            hide: 'Masquer le mot de passe',
            reset: 'Effacer le mot de passe',
        },
        current: {
            label: 'Mot de passe actuel',
            show: 'Afficher le mot de passe actuel',
            hide: 'Masquer le mot de passe actuel',
            reset: 'Effacer le mot de passe actuel',
        },
        new: {
            label: 'Nouveau mot de passe' ,
            show: 'Afficher le nouveau mot de passe',
            hide: 'Masquer le nouveau mot de passe',
            reset: 'Effacer le nouveau mot de passe',
        },
        confirmation: {
            label: 'Confirmation du mot de passe',
            show: 'Afficher le mot de passe de confirmation',
            hide: 'Masquer le mot de passe de confirmation',
            reset: 'Effacer le mot de passe de confirmation',
        },
        error: 'Merci de saisir un mot de passe...',
        wrong: 'Mot de passe erronné',
        security: 'Le mot de passe doit suivre les règles de sécurité.',
        rules: `
        Le mot de passe doit contenir entre {passwordMin} et {passwordMax} caractères, dont: au moins une lettre majuscule, au moins une lettre minuscule,
        au moins un chiffre, au moins un caractère spécial: {passwordAuthCar}
        `,
    },
    message: {
        reset: "Effacer le contenu du message",
        label: 'Message à adresser à l\'administrateur (au moins 6 caractères)',
    },
}